<template>
  <div class="list-modal h-card shadow">
    <div class="card-header">
      <div class="modal-title">Отмена брони</div>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal"
              aria-label="Закрыть"></button>
    </div>
    <div class="card-body">
      <div class="p-3 small">

        <div>
          <h5>{{ cabinetData.title }}</h5>
          <div>Дата: {{ dateFormat }}</div>
        </div>
        Выберите необходимые часы для отмены
      </div>

      <div class="d-flex flex-column  px-3 h-100">
        <div class="overflow-auto">
          <div class="d-flex flex-row gap-1" id="timecheck">
            <template v-for="(bData, index) in bookingMatrix" :key="bData.id">
              <div v-if="index && isViewGap(bData.totalMinutes)">
                <div class="block-gap">
                  ...
                </div>
              </div>

              <div class="block-line">
                <div class="form-check d-flex flex-column gap-2 align-items-center">
                  <input class="form-check-input" @change="handleSelection" type="checkbox" :value="bData.id"
                         v-model="selectedIds" :id="bData.id">
                  <label class="form-check-label" :for="bData.id">
                    <span class="hourBlock" :class="isErrorBlock(bData.id)">
                      <span class="block">{{ timeView1(bData) }}</span>
                      -
                      <span class="block">{{ timeView2(bData) }}</span>
                    </span>
                  </label>
                </div>
              </div>
              {{ setTimeViewTotalMinutes(bData.totalMinutes) }}
            </template>
          </div>
        </div>
        <div class="error-msg-block mt-3">
          <div v-if="validationMessage">
            <template v-for="(errorMsg, index) in validationMessage" :key="index">
              <div>{{ errorMsg }}</div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex align-items-center">
      <span v-show="loaderShow" class="spinner-border spinner-border-sm text-primary me-3"></span>
      <button class="ok-btn me-1" @click="cancelBooking" :disabled="btnDisabled">Отменить брони</button>
      <button class="close-btn" @click="closeCmodal">Закрыть</button>
    </div>


  </div>
</template>
<script>
import {closeModal} from "jenesius-vue-modal";
import {dateFormat} from "@/dateFormat";
// eslint-disable-next-line no-unused-vars
import {API} from "@/getapi";
import {useToast} from "vue-toastification";

let lastViewTotalMinutes = -1;
export default {
  name: 'CancelBookingsModalList',
  inject: [
    'URL_CANCEL',
  ],
  props: {
    bookingData: Object,
    cabinetData: Object,
    date: String
  },
  data() {
    return {
      restext: '',
      errorBlock: [],
      bookingMatrix: [],
      bookingLinkIdToMinutes: {},
      selectedIds: [], // Список выбранных для отмены ID
      validationMessage: "",
      timeLineIndex: [],
      loaderShow: false,
      btnDisabled: true,
    }
  },
  setup() {
    // Get toast interface
    const toast = useToast();
    return {toast}
  },
  mounted() {
    // this.buildTimeLineIndex()
    this.biuldMatrix()

  },
  computed: {
    dateFormat() {
      return dateFormat.strToFormat(this.date)
    },
  },
  methods: {

    setTimeViewTotalMinutes(val) {
      lastViewTotalMinutes = val
    },
    isViewGap(currentMinutes) {
      return lastViewTotalMinutes + 30 != currentMinutes
    },
    isErrorBlock(id) {
      return this.errorBlock.includes(id) ? 'error-block' : ''
    },
    biuldMatrix() {
      const minuteToNumber = (m) => (m === "1/2" ? 0 : 30);
      let b_link = {}
      for (const key in this.bookingData) {

        let b = this.bookingData[key]

        b['totalMinutes'] = b.hour * 60 + minuteToNumber(b.minute)
        if(b['canCancel']){
          this.bookingMatrix.push(b)
          this.bookingLinkIdToMinutes[b.id] = b['totalMinutes']
          b_link[b['totalMinutes']] = b.id
        }
      }
      const timeLine = {};
      for (let minutes = 0; minutes < 1440; minutes += 30) {
        timeLine[minutes] = minutes in b_link ? b_link[minutes] : false
      }
      this.timeLineIndex = timeLine
    },
    handleSelection() {
      // Проверяем правила отмены
      const {isValid, violations} = this.checkCancellationRules();
      if (!isValid) {
        this.validationMessage = violations
        this.btnDisabled = true
      } else {
        this.validationMessage = []
        if(this.selectedIds.length){
          this.btnDisabled = false
        }else{
          this.btnDisabled = true
        }

      }
    },
    checkCancellationRules() {
      const violations = []
      const selected = []
      var error1 = false
      var error2 = false
      this.errorBlock = []
      for (let i = 0; i < this.selectedIds.length; i++) {
        const selectedBookingId = this.selectedIds[i];
        if (selectedBookingId in this.bookingLinkIdToMinutes) {
          selected.push(this.bookingLinkIdToMinutes[selectedBookingId])
        }
      }
      // console.log(selected)
      for (let timeline in this.timeLineIndex) {
        let tl = Number(timeline)
        let prevIndex = tl == 0 ? 1440 : tl - 30
        let prevPrevIndex = tl == 0 ? 1440 - 30 : tl > 30 ? tl - 60 : 1440
        let nextIndex = tl == 1440 ? 0 : tl + 30
        let nextNextIndex = tl == 1440 ? 30 : tl + 60

        let prevBooking = selected.includes(prevIndex) ? false : this.timeLineIndex[prevIndex]
        let prevPrevBooking = selected.includes(prevPrevIndex) ? false : this.timeLineIndex[prevPrevIndex]
        let currentBooking = selected.includes(tl) ? false : this.timeLineIndex[tl]
        let currentBookingId = this.timeLineIndex[tl]
        let nextBooking = selected.includes(nextIndex) ? false : this.timeLineIndex[nextIndex]
        let nextNextBooking = selected.includes(nextNextIndex) ? false : this.timeLineIndex[nextNextIndex]


        if (!prevPrevBooking && !prevBooking && currentBooking && !nextBooking && !nextNextBooking) {
          this.errorBlock.push(currentBooking)
          if (!error1) {
            violations.push(
                `Нельзя оставлять 1 бронь в 30 минут.`
            );
            error1 = true
          }
        }

        if (prevBooking && !currentBooking && nextBooking) {
          this.errorBlock.push(currentBookingId)
          if (!error2) {
            violations.push(
                `Нельзя оставлять  промежуток  в 30 минут между бронями.`
            );
            error2 = true
          }

        }

        // console.log(timeline, prevPrevIndex, prevIndex, nextIndex, nextNextIndex)
      }
      return {isValid: violations.length === 0, violations};
    },
    timeView(data) {
      return 'c ' + this.timeView1(data) + ' до ' + this.timeView2(data);
    },
    timeView1(data) {
      return data.hour + ':' + data.minuteView;
    },
    timeView2(data) {
      let hour = data.minuteView == '30' ? data.hour + 1 : data.hour;
      let minute = data.minuteView == '30' ? '00' : '30';
      return hour + ':' + minute;
    },
    closeCmodal() {
      closeModal();
    },
    cancelBooking() {
      // URL_BOOKING
      this.btnDisabled = true
      this.loaderShow = true

      API.get(this.URL_CANCEL, {
        cancelIds: this.selectedIds
      }).then(({data}) => {
        console.log(data)
        if (data.isOk) {

          this.toast.info("Отмена бронирования прошло успешно.");
          this.$emitter.emit('mybookingCancelDone',this.selectedIds)

        } else {
          this.toast.error('Ошибка отмены бронирования.');
          console.error("Error:", data.errors)
        }
      }).catch((err) => {
        API.catch(err)
      }).finally(() => {
        this.loaderShow = false
        this.btnDisabled = true
        closeModal();
      })

    }
  }
}
</script>
<style scoped>
.error-msg-block {
  font-size: 0.9rem;
  color: #c13535;
  min-height: 3rem;
}

.restest {
  font-size: 0.9rem;
  height: 100%;
}

.h-100 {
  height: 100%;
}

.form-check {
  padding: 0;
}

.form-check .form-check-input {
  margin-left: 0;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.change-wrap {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}

.add-btn-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.add-comment-btn {
  font-size: 0.7em;
  border: none;
  padding: 0.4em 1em;
  border-radius: 1em;
  background: #dd9f4c57;
  color: #704a00;
  line-height: 1.35em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  /*text-shadow: 0px 1px 0px #fff;*/
  transition: all ease .3s;
}

.add-comment-btn:hover {
  background: #dd9f4c77;
}

.list-modal {
  width: 460px;
  max-height: 100vh;
  container-name: list-modal-container;
  container-type: inline-size;
}

.list-modal .card-body {
  padding: 0;
  overflow: auto;
  height: 400px;
  height: auto;
  max-height: 95vh;
}

@container list-modal-container {
  .list-modal .card-body {
    height: 80cqh;
  }
}

.hourBlock {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 4em;
  width: 4.2em;
  min-width: 4.2em;
  border: 1px solid #c7bbbb7a;
  padding: 0.1rem 0.1rem;
  border-radius: 5px;
  font-size: .7em;
  line-height: 1em;
  align-items: center;
  color: #fff;
  background: #81b29a;
  justify-content: center;
  border: 1px solid #17573800;
  box-shadow: -4px 6px 10px 0px #211e1e40;
  user-select: none;
}

.block {
  display: block;
}

.mycomment {
  font-size: .85em;
}

.mycomment.adm {
  color: #782f36;
}

.label {
  font-size: 0.65em;
  color: #9f9f9f;
}

.label.adm {
//font-size: 0.65em; //color: #c15761;
}

.block-line {

  padding: 0.2em;

}

.block-line * {
  cursor: pointer;
}

.block-line:nth-of-type(2n) {
  background: #fff8db59;
}

.error-block {
  background: #b99595;
}

.block-gap {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding-top: 1rem;
}
</style>